import { useMemo } from 'react';
import { ColumnDefinition } from 'react-tabulator';
import { propertyOf } from '../../../utils/propertyOf';
import { formatDate } from '../../../utils/dateUtils';
import { PPSCardMembershipRequestResponse } from '../../../swagger/putujmoAdminService';

export const useTableColumnsMemo = () => {
	const columns: ColumnDefinition[] = useMemo(
		() => [
			{
				title: 'Datum',
				field: propertyOf<PPSCardMembershipRequestResponse>('createdAt'),
				formatter: (cell: any) => formatDate(cell.getValue()),
			},
			{
				title: 'Ime',
				field: propertyOf<PPSCardMembershipRequestResponse>('firstName'),
			},
			{
				title: 'Prezime',
				field: propertyOf<PPSCardMembershipRequestResponse>('lastName'),
			},
			{
				title: 'Email',
				field: propertyOf<PPSCardMembershipRequestResponse>('email'),
			},
			{
				title: 'Telefon',
				field: propertyOf<PPSCardMembershipRequestResponse>('phone'),
			},
      {
				title: 'Adresa',
				field: propertyOf<PPSCardMembershipRequestResponse>('address'),
			},
			{
				title: 'Grad',
				field: propertyOf<PPSCardMembershipRequestResponse>('city'),
			},
			{
				title: 'Status',
				field: propertyOf<PPSCardMembershipRequestResponse>('isPaid'),
				formatter: (cell: any) => {
					const isPaid = cell.getValue();
					return isPaid
						? '<span style="color:#27ae60;font-weight:bold">Plaćeno</span>'
						: '<span style="color:#7f8c8d">Na čekanju</span>';
				},
			},
			{
				title: 'Datum plaćanja',
				field: propertyOf<PPSCardMembershipRequestResponse>('paidAt'),
				formatter: (cell: any) => {
					const value = cell.getValue();
					return value ? formatDate(value) : '';
				},
			},
		],
		[]
	);

	return columns;
};
